export default __webpack_public_path__ + "static/media/ChargeItUp.374666f0.svg";